export default "__VITE_ASSET__1f0d7713__"